import { createWorker, type Worker } from 'tesseract.js'

/** Usamos OCR offline para sugerir IDs de muestrario y nombres editables. */

let workerPromise: Promise<Worker> | null = null

/** Reutilizamos un único worker para evitar arranques costosos por foto. */
function obtenerWorkerOcr(): Promise<Worker> {
  if (!workerPromise) {
    workerPromise = createWorker('eng', 1, {
      workerPath: '/tesseract/worker.min.js',
      corePath: '/tesseract/tesseract-core-lstm.wasm.js',
      langPath: '/tesseract/eng',
      cacheMethod: 'none', // los assets ya se sirven desde public/tesseract
    })
  }
  return workerPromise
}

export async function leerTextoDeImagen(blob: Blob): Promise<string> {
  const worker = await obtenerWorkerOcr()
  const { data } = await worker.recognize(blob)
  return data.text
}

/** Extraemos el primer token que parezca código de muestrario. */
export function extraerIdMuestrario(texto: string): string | null {
  const candidatos = texto.match(/\b[A-Za-z0-9][A-Za-z0-9.-]{2,11}\b/g) ?? []
  return candidatos.find((c) => /\d/.test(c)) ?? null
}

/** Elegimos la línea más probable como nombre de proveedor. */
export function extraerNombreProveedor(texto: string): string | null {
  const lineas = texto
    .split('\n')
    .map((l) => l.trim())
    .filter((l) => l.length >= 3)
    .filter((l) => !l.includes('@'))
    .filter((l) => !/^[+()\d\s-]+$/.test(l))
    .filter((l) => /[a-zA-Z]{2,}/.test(l))

  if (lineas.length === 0) return null
  return lineas.reduce((mejor, actual) => (actual.length > mejor.length ? actual : mejor), '')
}
